import React, { Component } from "react";
import { connect } from "react-redux";
import { updateHSPICEConfig, updateHspiceConfigStatus } from "../store/channel/action";
import SimulationContent from "../SimulationContent"
import { filterTestPoint } from "../../../services/Andes_v2/channel";
import designConstructor from "../../../services/helper/designConstructor";
import { PRE_LAYOUT } from "../../../constants/designVendor";
import { getPreLayoutInfoById } from "../../../services/Andes_v2/preLayout";

class HspiceSimulation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preLayoutInfo: {}
    }
  }

  async componentDidMount() {
    const { isPreLayout, designId } = this.props;
    await this.getPreLayoutInfo(isPreLayout, designId);
  }

  async componentDidUpdate(prevProps) {
    const { designId, isPreLayout } = this.props;
    if (prevProps.designId !== designId) {
      await this.getPreLayoutInfo(isPreLayout, designId, true);
    }
  }

  getPreLayoutInfo = async (isPreLayout, designId, isUpdateComponentModel) => {
    if (isPreLayout) {
      // get prelayout info
      const res = await getPreLayoutInfoById(designId);
      this.setState({
        preLayoutInfo: res.content ? res.content : {}
      }, () => {
        isUpdateComponentModel && this.props.updateComponentModel();
      })
    }
  }

  render() {
    const { preLayoutInfo = {} } = this.state;
    const { components, comp_merges, hspiceConfig, preLayoutInfo: propsPreLayoutInfo } = this.props;
    const { controller, device } = hspiceConfig;
    const _components = filterTestPoint(components, comp_merges);
    return <SimulationContent
      {...this.props}
      components={_components}
      txCompInfo={_components.find((item) => item.name === controller) || {}}
      rxCompInfo={_components.find((item) => item.name === device) || {}}
      preLayoutModel={(propsPreLayoutInfo || preLayoutInfo).preLayoutModel}
    />
  }
}

const mapState = (state) => {
  const {
    channel: {
      channelInfo: { content = {}, hspiceConfig, type, designId },
      channelId,
      channelLoading,
      hspiceConfigStatus
    },
    library: { libraryStatus },
    preLayout: { info }
  } = state.AndesV2Reducer;
  const {
    components = [],
    signals = [],
    simulationSolver,
    comp_merges
  } = content;
  const design = designConstructor.getDesign(designId) || {};

  return {
    components,
    signals,
    hspiceConfig,
    channelId,
    serdesType: type,
    libraryStatus,
    channelLoading,
    simulationSolver,
    hspiceConfigStatus,
    comp_merges,
    designId,
    designType: design.type,
    isPreLayout: design.vendor === PRE_LAYOUT,
    preLayoutInfo: (info[designId] || {}).preLayoutInfo
  };
};

const mapDispatch = (dispatch) => ({
  _updateHSPICEConfig(hspiceConfig) {
    dispatch(updateHSPICEConfig(hspiceConfig));
  },
  _updateHspiceConfigStatus(status) {
    dispatch(updateHspiceConfigStatus(status));
  },
});

export default connect(mapState, mapDispatch)(HspiceSimulation);
